module.exports = __webpack_public_path__ + "img/other-modal-icon.330d8975.svg";